<template lang="pug">
form(@submit.prevent="onRecusar")
  modal(:active="true", title="Recusar NFS-e", @close="$router.back()")
    div(slot="modal-body")
      .toast.toast-warning Se você não tomou este serviço ou existe alguma informação incorreta pode recusar esta nota
      .form-group
        label.form-label {{ "nfe_recepcao.nfe_situacao_tomador" | tModel }}
        select.form-select(v-model="nfeRecepcao.nfe_situacao_tomador_id")
          option(v-for="situacao in situacaoTomadores", :value="situacao.id") {{ situacao.descricao }}
      .form-group
        label.form-label(for="input-descricao") {{ "nfe_recepcao.descricao" | tModel }}
        textarea#input-descricao.form-input(
          rows="5",
          v-model="nfeRecepcao.descricao"
        )
      button.btn.btn-lg.float-right.btn-primary(:disabled="!valid") {{ "views.buttons.save.label" | translate }}
</template>

<script>
import NfeRecepcao from "@/models/NfeRecepcao";
import toastErrors from "@/lib/errors/toastErrors";
import notasRecebidas from "@/api/notasRecebidas";

export default {
  vuex: { notasRecebidas: { getters: ["loading"], actions: ["fetchRecusar"] } },

  data() {
    return {
      nfeRecepcao: new NfeRecepcao({ nfe_id: this.$route.params.id }),
      situacaoTomadores: [],
    };
  },

  computed: {
    valid() {
      return (
        this.nfeRecepcao.descricao !== "" &&
        this.nfeRecepcao.nfe_situacao_tomador_id !== null
      );
    },
  },
  methods: {
    async onRecusar() {
      try {
        await this.fetchRecusar(this.nfeRecepcao);
        this.$toaster.success("Nota recusada");
        this.$router.replace(`/app/notas-recebidas/${this.$route.params.id}`);
      } catch (e) {
        toastErrors(e);
      }
    },
    fetchNfeSituacaoTomadores() {
      notasRecebidas.situacaoTomadores().then((res) => {
        this.situacaoTomadores = res;
      });
    },
  },
  created() {
    this.fetchNfeSituacaoTomadores();
  },
};
</script>
